import { useMediaQuery } from 'react-responsive'
import { GRID_BREAKPOINT_SM } from '@breakpoints'
import debounce from 'debounce'
import { withRouter } from 'i18n/utils'
import { fetchEvents, setSearchEventInputValue, removeSearchEventInputValue, setEvent } from '../actions'
import { eventsSearchPendingSelector, eventsListSelector, searchEventInputSelector } from '../selectors'
import useBeforeFirstRender from 'shared/hooks/useBeforeFirstRender'
import EventsSearchModal from 'search/components/EventsSearchModal'
import Modal from '@components/Modal'
import Select from '@components/Select'
import MenuList from '@components/Select/showResults'
import { RateCurrency } from 'shared/price-utilities'

const EventSearch = ({
    fetchEvents,
    isClearable,
    scaleEffect,
    size,
    icon,
    events,
    onFocusChange,
    eventsSearchPending,
    removeSearchEventInputValue,
    setSearchEventInputValue,
    setEvent,
    history,
}) => {
    const [modalOpen, setModalOpen] = React.useState(false)
    const isTabletOrDesktop = useMediaQuery({ minWidth: GRID_BREAKPOINT_SM })

    const toggleModal = () => {
        setModalOpen(!modalOpen)
    }

    useBeforeFirstRender(() => {
        removeSearchEventInputValue()
    })

    const onSelectInputChange = (value, reason) => {
        if (reason.action === 'input-blur' || reason.action === 'menu-close') {
            return
        }

        fetchEvents({ eventName: value })
        setSearchEventInputValue(value)
    }

    const onSelectInputChangeDenounced = debounce(onSelectInputChange, 500)

    const onEventChange = event => {
        if (event && !event.isSoldOut) {
            setEvent(event)
            history.push(`/booking/${event.locationId}/events`)
        }
    }

    const showPrice = (amount, currencySymbol) => <RateCurrency value={amount} currency={currencySymbol} />

    return (
        <>
            <Select
                noOptionsCustomMessage={<T>search.no-results</T>}
                enterTermMessage={<T>select.enter-term</T>}
                isLoading={eventsSearchPending}
                borders={false}
                arrow={false}
                isClearable={isClearable}
                scaleEffect={scaleEffect}
                size={size}
                icon={icon}
                placeholder={<T>input.placeholder.search.event</T>}
                options={events}
                showPrice={showPrice}
                components={events.length > 4 ? props => <MenuList {...props} onClick={toggleModal} /> : null}
                onInputChange={onSelectInputChangeDenounced}
                onChange={onEventChange}
                onFocus={onFocusChange}
                onBlur={onFocusChange}
                fontFamily="Poppins"
                isTabletOrDesktop={isTabletOrDesktop}
                filterOption={() => true}
                className="locationSelect"
            />
            {modalOpen && <Modal onClose={toggleModal} Component={EventsSearchModal} />}
        </>
    )
}

EventSearch.propTypes = {
    size: PropTypes.oneOf(['small', 'large']).isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    isClearable: PropTypes.bool,
    scaleEffect: PropTypes.bool,
    onFocusChange: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
    eventsSearchPending: eventsSearchPendingSelector,
    events: eventsListSelector,
    searchEventInput: searchEventInputSelector,
})

const mapDispatchToProps = {
    fetchEvents,
    setSearchEventInputValue,
    removeSearchEventInputValue,
    setEvent,
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(EventSearch)
